import type { CompanyProfilePersonDto } from '@/api/companies'

/**
 * Two states, because a lead only ever exists on engagement — there is no middle ground the data
 * can tell apart. Depth beyond that is the signal bars' job, not a third label.
 *
 * Shape and label both carry it, so hue is never the only signal.
 *
 * Its own file because companyPeopleColumns.tsx exports a plain function, and a module mixing a
 * component with a non-component export breaks fast refresh.
 */
export function CompanyPersonStatus({ status }: { status: CompanyProfilePersonDto['Status'] }) {
  const converted = status === 'Converted'
  return (
    <span
      class={`inline-flex items-center gap-1.5 text-xs whitespace-nowrap ${
        converted
          ? 'font-semibold text-primary-700 dark:text-primary-400'
          : 'text-slate-500 dark:text-slate-400'
      }`}
    >
      <span aria-hidden="true">{converted ? '●' : '○'}</span>
      {status}
    </span>
  )
}
